(function () {
  var root = document.getElementById('SVQuickAdd');
  if (!root) return;

  var loadingEl = root.querySelector('[data-sv-quick-add-loading]');
  var contentEl = root.querySelector('[data-sv-quick-add-content]');
  var titleEl = root.querySelector('[data-sv-quick-add-title]');
  var priceEl = root.querySelector('[data-sv-quick-add-price]');
  var pillsEl = root.querySelector('[data-sv-quick-add-pills]');
  var noteEl = root.querySelector('[data-sv-quick-add-note]');
  var errorEl = root.querySelector('[data-sv-quick-add-error]');
  var submitBtn = root.querySelector('[data-sv-quick-add-submit]');
  var headingEl = root.querySelector('[data-sv-quick-add-heading]');
  var moneyFormat = root.getAttribute('data-money-format') || 'Rs. {{amount}}';

  var selectedVariant = null;
  var changeLineKey = null;
  var changeLineQuantity = 1;

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function setError(message) {
    errorEl.textContent = message;
    errorEl.hidden = !message;
  }

  function setNote(message) {
    noteEl.textContent = message;
    noteEl.hidden = !message;
  }

  function resetSubmit() {
    selectedVariant = null;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Select a size';
  }

  function open() {
    root.classList.add('is-open');
    document.body.classList.add('sv-quick-add-open');
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('sv-quick-add-open');
  }

  function showLoading() {
    loadingEl.hidden = false;
    contentEl.hidden = true;
    setError('');
    setNote('');
    resetSubmit();
  }

  function showContent() {
    loadingEl.hidden = true;
    contentEl.hidden = false;
  }

  // Builds the list of pills from product data.
  // Single "Default Title" variant → one "One size" pill.
  // One option (the normal case: Size) → a pill per option value.
  // Multi-option products → a pill per variant title (rare; kurta sets are size-only).
  function buildPills(product) {
    var pills = [];
    var defaultOnly =
      product.variants.length === 1 && product.variants[0].title === 'Default Title';

    if (defaultOnly) {
      pills.push({ label: 'One size', variant: product.variants[0] });
    } else if (product.options.length === 1) {
      var seen = {};
      product.variants.forEach(function (variant) {
        var value = variant.option1;
        if (seen[value]) {
          // Prefer an available variant for this value
          if (!seen[value].available && variant.available) seen[value] = variant;
          return;
        }
        seen[value] = variant;
        pills.push({ label: value, variant: null, value: value });
      });
      pills.forEach(function (pill) {
        pill.variant = seen[pill.value];
      });
    } else {
      product.variants.forEach(function (variant) {
        pills.push({ label: variant.title, variant: variant });
      });
    }
    return pills;
  }

  function renderProduct(product) {
    titleEl.textContent = product.title;
    priceEl.textContent = formatMoney(product.price);
    pillsEl.innerHTML = '';

    buildPills(product).forEach(function (pill) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sv-pill';
      btn.textContent = pill.label;

      if (!pill.variant.available) {
        btn.classList.add('sv-pill--soldout');
        btn.setAttribute('aria-disabled', 'true');
        btn.addEventListener('click', function () {
          setNote('Size ' + pill.label + ' is out of stock right now.');
        });
      } else {
        btn.addEventListener('click', function () {
          pillsEl.querySelectorAll('.sv-pill').forEach(function (el) {
            el.classList.remove('sv-pill--selected');
          });
          btn.classList.add('sv-pill--selected');
          selectedVariant = pill.variant;
          priceEl.textContent = formatMoney(pill.variant.price);
          setNote('');
          setError('');
          submitBtn.disabled = false;
          submitBtn.textContent = (changeLineKey ? 'Update size · ' : 'Add to cart · ') + pill.label;
        });
      }

      pillsEl.appendChild(btn);
    });

    showContent();
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var cartLink = document.querySelector('.sv-header__icon[aria-label="Cart"]');
        if (!cartLink) return;
        var countEl = cartLink.querySelector('.sv-header__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'sv-header__cart-count';
            cartLink.appendChild(countEl);
          }
          countEl.textContent = cart.item_count;
        }
      });
  }

  function addVariant(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Could not add to cart.');
        });
      }
      return response.json();
    });
  }

  // Shopify has no "change variant of an existing line" endpoint — swapping a
  // size is a remove-old + add-new pair. The new line lands at the end of the
  // cart rather than in its original position; an honest constraint of the
  // platform, not a bug.
  function changeVariant(oldLineKey, newVariantId, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldLineKey, quantity: 0 })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Could not update size.');
          });
        }
        return addVariant(newVariantId, quantity);
      });
  }

  function addToCart() {
    if (!selectedVariant) return;
    submitBtn.disabled = true;
    submitBtn.textContent = changeLineKey ? 'Updating…' : 'Adding…';
    setError('');

    var request = changeLineKey
      ? changeVariant(changeLineKey, selectedVariant.id, changeLineQuantity)
      : addVariant(selectedVariant.id, 1);

    request
      .then(function () {
        submitBtn.textContent = changeLineKey ? 'Updated ✓' : 'Added to cart ✓';
        updateCartCount();
        setTimeout(function () {
          close();
          // Fired after this drawer finishes closing so the cart drawer's
          // slide-in doesn't overlap this one's slide-out.
          document.dispatchEvent(new CustomEvent('sv:cart:updated'));
        }, 1200);
      })
      .catch(function (error) {
        submitBtn.disabled = false;
        submitBtn.textContent = changeLineKey ? 'Update size' : 'Add to cart';
        setError(error.message);
      });
  }

  function openForHandle(handle) {
    showLoading();
    open();

    fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load product.');
        return response.json();
      })
      .then(renderProduct)
      .catch(function (error) {
        loadingEl.hidden = true;
        setError(error.message);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sv-quick-add-trigger]');
    if (trigger) {
      // The trigger sits inside the product card's <a> — stop the navigation.
      event.preventDefault();
      event.stopPropagation();

      var lineKey = trigger.getAttribute('data-sv-cart-change-key');
      changeLineKey = lineKey || null;
      changeLineQuantity = lineKey ? parseInt(trigger.getAttribute('data-sv-cart-change-quantity'), 10) || 1 : 1;
      if (headingEl) headingEl.textContent = changeLineKey ? 'Change size' : 'Select size';

      openForHandle(trigger.getAttribute('data-product-handle'));
      return;
    }

    if (event.target.closest('[data-sv-quick-add-close]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  submitBtn.addEventListener('click', addToCart);
})();
